module.exports = __webpack_public_path__ + "img/16.893ec1a3.jpg";